module.exports = __webpack_public_path__ + "img/ring_y_s_1_1@2x.7730e684.png";